import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import { makeGetTask } from 'selectors/tasks';

import { updateTask } from 'actions/tasks';

import { useCanUser } from 'shared-hooks/permission';

import EmbedPane from 'components/EmbedPane';

const TaskEmbed = ({ id, taskEmbedUrl, createdBy, onRemove }) => {
    const canEdit = useCanUser('editTask', createdBy);

    const handleUrlChange = useCallback(nextValue => {
        updateTask(id, {
            embed_url: nextValue
        });
    }, [id]);

    const handleEmbedRemove = useCallback(() => {
        updateTask(id, {
            embed_url: null
        });

        onRemove && onRemove();
    }, [id, onRemove]);

    return (
        <div className="task-embed">
            <EmbedPane url={taskEmbedUrl} onChange={canEdit && handleUrlChange} onRemove={canEdit && handleEmbedRemove} />
        </div>
    )
}

const makeMapStateToProps = () => {
    const getTask = makeGetTask();

    return ({ tasks }, ownProps) => {
        const task = getTask(tasks.items, ownProps.id);

        return {
            taskEmbedUrl: task?.embed_url,
            createdBy: task?.created_by
        }
    }
}

export default connect(makeMapStateToProps)(TaskEmbed);
